import useIsImageColorDark from 'hooks/useIsImageColorDark';
import { BackgroundColorTypeHex } from 'components/ColorHelper/ColorTypeHelperHex';

const checkHeroDark = hero => {
  const heroBackgroundImage =
    hero?.backgroundImage?.fluid?.src ||
    hero?.backgroundImage?.image?.file?.url ||
    hero?.backgroundImage?.image?.fluid?.src ||
    hero?.image?.fluid?.src ||
    hero?.styles?.backgroundImage?.image?.fluid?.src;

  const heroBackgroundColor =
    hero?.background && (BackgroundColorTypeHex[hero.background] || hero.background);
  const { imageDark, colorDark } = useIsImageColorDark(heroBackgroundImage, heroBackgroundColor);
  return imageDark || colorDark;
};

export default checkHeroDark;
